import Vue from 'vue'
import router from '@/router'
import VueYandexMetrika from 'vue-yandex-metrika'
Vue.use(VueYandexMetrika, {
    id: 67424773,
    router: router,
    env: process.env.NODE_ENV
})